import { metaSetter } from '@app/utils/meta-setter'
import { BlogWrapper } from '@app/components/blog/blog-wrapper'
import type { BlogPageProps } from '@app/types'
import { BlogLayout } from '@app/components/blog-layout'
import { Header, Header2 } from '@app/components/general/header'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { Card } from '@app/components/stateless/card/card'
import { featuredItems } from '@app/data/blog/posts'
import loadNamespaces from 'next-translate/loadNamespaces'
import type { GetStaticProps } from 'next'
import { I18nDictionary } from 'next-translate'

export const getStaticProps: GetStaticProps<{
  __lang: string
  __namespaces?: Record<string, I18nDictionary>
}> = async (ctx) => {
  return {
    props: await loadNamespaces({
      ...ctx,
      pathname: '/blog/categories/accessibility',
    }),
  }
}

const featuredFilters = featuredItems.filter(
  (item) => item.category === 'accessibility'
)

function Accessibility(props: BlogPageProps) {
  const { t: tt } = useTranslation('categories-accessibility')

  return (
    <BlogWrapper {...props} websiteUrl={'/blog'}>
      <div className='px-4 mx-auto container max-w-5xl py-5'>
        <div className='gap-3 flex flex-wrap w-full rounded'>
          <div className='w-full'>
            <Header className='text-center'>
              {tt('show-all')} {tt('accessibility')}
            </Header>
          </div>
        </div>

        <div className='py-4'>
          <Header2 className='text-center sr-only'>
            {tt('accessibility')}
          </Header2>
        </div>

        <div className='grid grid-cols-1 md:grid-cols-3 gap-3 pb-12'>
          {featuredFilters.map(
            ({ href, category, date, backgroundImage, index }, i) => {
              return (
                <Card
                  key={`blog-card-${i}`}
                  category={category}
                  href={href}
                  date={date}
                  authorName='Jeff Mendez'
                  cardTitle={`features.${index}.title`}
                  cardDescription={`features.${index}.details`}
                  backgroundImage={backgroundImage}
                />
              )
            }
          )}
        </div>
      </div>
    </BlogWrapper>
  )
}

Accessibility.getLayout = BlogLayout

export default metaSetter(
  { Accessibility },
  {
    gql: false,
    rest: false,
    translation: 'categories-accessibility',
  }
)
